import React from 'react'
import './styles/govtschemes.css'

const GovtSchemes = () => {
  return (
    <div>
      govt schemes
    </div>
  )
}

export default GovtSchemes
